import React from "react";

export default function CompanyUserDetail(){
    return(
        <>
        BankAccountDetail
        </>
    )
}